module.exports = __webpack_public_path__ + "static/img/ex_default_banner.11463b63.jpg";